import { baseApi } from "./baseApi";

const aePipelineApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAePipeline: builder.query({
      query: () => ({
        url: "/ae-pipeline",
        method: "GET",
      }),
      providesTags: ["AePipeline"],
    }),
  }),
});

export const { useGetAePipelineQuery } = aePipelineApi;
export default aePipelineApi;
